// DevExtreme license key.
// File excluded from VCS via .gitignore — do not commit.
const licenseKey = 'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogIjUxMDRmNTUxLTU2ODEtNDU4ZS05NTIzLTg5YzY4ODk4ZTE2YiIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjUyCn0=.r9P1qtJbgKygx+QBL7hpiJboYt2d2CqQZc6dcqUKLEur0+vuO54O1GVvRZPqYEoG4EHAOmPwq9XJcCG6WmvoA8j4qj3R7F+kpB0g9jj3yOikgGVfDWY50Xf2f/KPydqG/hUT+A==';

export default licenseKey;
